import { useState } from "react";
import api from "../api/api";

export default function ReminderPage() {
  const [reminders, setReminders] = useState([]);

  const [form, setForm] = useState({
    meeting_id: "",
    remind_at: "",
  });

  // LOAD
  const load = async () => {
    try {
      const res = await api.get("/reminder");
      setReminders(res.data || []);
    } catch (err) {
      console.log(err);
      alert("Error loading reminders");
    }
  };

  // CREATE
  const create = async () => {
    const { meeting_id, remind_at } = form;

    if (!meeting_id || !remind_at) {
      return alert("All fields are mandatory");
    }

    try {
      await api.post("/reminder", form);

      alert("Reminder Created");

      setForm({
        meeting_id: "",
        remind_at: "",
      });

      load();
    } catch (err) {
      console.log(err);
      alert("Error creating reminder");
    }
  };

  return (
    <div className="min-h-screen -mt-10">
      <h2 className="text-4xl font-semibold text-[#030244] text-center mb-8">
        Reminder
      </h2>

      {/* FORM */}
      <div className="max-w-md mx-auto bg-white shadow-lg p-8 rounded-xl border">
        <div className="flex flex-col gap-4">
          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Meeting ID"
            value={form.meeting_id}
            onChange={(e) =>
              setForm({ ...form, meeting_id: e.target.value })
            }
          />

          <input
            type="datetime-local"
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            value={form.remind_at}
            onChange={(e) =>
              setForm({ ...form, remind_at: e.target.value })
            }
          />
        </div>

        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={create}
            className="bg-[#030244] hover:bg-[#040261] text-lg text-white px-6 py-2 rounded"
          >
            Create
          </button>

          <button
            onClick={load}
            className="bg-green-700 hover:bg-green-600 text-lg text-white px-6 py-2 rounded"
          >
            Load
          </button>
        </div>
      </div>

      {/* TABLE */}
      <div className="w-full max-w-5xl mx-auto bg-white shadow mt-12 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[800px]">
          <thead className="bg-[#030244] text-white text-xl">
            <tr>
              <th className="p-3 text-center font-medium border">Reminder ID</th>
              <th className="p-3 text-center font-medium border">Meeting ID</th>
              <th className="p-3 text-center font-medium border">Remind At</th>
            </tr>
          </thead>

          <tbody>
            {reminders.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center p-4 text-xl">
                  No Data Found
                </td>
              </tr>
            ) : (
              reminders.map((r) => (
                <tr key={r.reminder_id} className="border-b text-lg">
                  <td className="p-3 text-center border text-gray-700">{r.reminder_id}</td>
                  <td className="p-3 text-center border text-gray-700">
                    {r.meeting_id}
                  </td>
                  <td className="p-3 text-center border text-gray-700">
                    {new Date(r.remind_at).toLocaleString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      </div>
    </div>
  );
}